import { Component, OnInit, Injector } from '@angular/core';
import { ModalService } from '../../../services/util/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  contentComponent!: any;
  contentInjector!: Injector;
  isOpen = false;

  constructor(
    private modalService: ModalService,
    private defaultInjector: Injector
  ) {}

  ngOnInit(): void {
    this.modalService.modalState.subscribe(
      ({ isOpen, contentComponent, contentInjector }) => {
        this.isOpen = isOpen;
        this.contentComponent = contentComponent;
        this.contentInjector = contentInjector || this.defaultInjector;
      }
    );
  }

  closeModal() {
    this.modalService.close();
  }
}
